import gql from 'graphql-tag';

export const POST_REMOVE_HISTORY = gql`
  mutation deleteHistory($mangaId: ID!) {
    deleteHistory(mangaId: $mangaId) {
      _id
    }
  }
`;
